import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';

import styles from './index.module.css';
import lockOutline from '../../../assets/lock-outline.svg';

interface Props extends Pick<Modal.Props, 'isOpen'> {}

const PaymentLoadingModal: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  return (
    <Modal
      appElement={document.getElementById('root') ?? undefined}
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      className={styles.ModalContent}
      overlayClassName={styles.Overlay}
      {...props}
    >
      <img className={styles.LockIcon} alt="lock" src={lockOutline} />
      <div className={styles.ModalTitle}>{t('Securing your payment')}</div>
      <div className={styles.LoadingBase}>
        <div className={styles.LoadingBar} />
      </div>
    </Modal>
  );
};

export default PaymentLoadingModal;
